import { TipoEventoNFeEnum } from '../enums/dfe/tipo-evento-nfe.enum';

/** Mínimo de caracteres da justificativa exigida pela SEFAZ na Operação não realizada. */
export const TAMANHO_MINIMO_JUSTIFICATIVA_MANIFESTACAO = 15;

/**
 * Eventos da manifestação do destinatário da NF-e e os textos da confirmação. Regra comum ao detalhe do
 * painel de notas recebidas e à Central de NFs de entrada.
 */
export const EVENTOS_MANIFESTACAO_NFE = [
  {
    idTipoEvento: TipoEventoNFeEnum.CienciaEmissao,
    rotulo: 'Ciência da operação',
    titulo: 'Confirmar ciência da operação',
    descricao: 'Isso indica que você tem ciência da emissão da nota, mas ainda não confirmou a operação.',
    motivoJaRegistrado: 'A nota não está mais aguardando ciência da operação.',
    isJustificativaObrigatoria: false,
  },
  {
    idTipoEvento: TipoEventoNFeEnum.ConfirmacaoOperacao,
    rotulo: 'Confirmação da operação',
    titulo: 'Confirmar operação',
    descricao: 'Atenção: esta ação é irreversível e confirma o recebimento da mercadoria ou serviço.',
    motivoJaRegistrado: 'A operação já foi confirmada.',
    isJustificativaObrigatoria: false,
  },
  {
    idTipoEvento: TipoEventoNFeEnum.DesconhecimentoOperacao,
    rotulo: 'Desconhecimento da operação',
    titulo: 'Registrar desconhecimento',
    descricao: 'Esta ação informa que a operação não foi solicitada por você.',
    motivoJaRegistrado: 'O desconhecimento já foi registrado.',
    isJustificativaObrigatoria: false,
  },
  {
    idTipoEvento: TipoEventoNFeEnum.OperacaoNaoRealizada,
    rotulo: 'Operação não realizada',
    titulo: 'Registrar operação não realizada',
    descricao: 'Esta ação informa que a operação não ocorreu (ex: recusa de recebimento).',
    motivoJaRegistrado: 'A operação não realizada já foi registrada.',
    isJustificativaObrigatoria: true,
  },
];

/** Eventos conclusivos, oferecidos ao manifestar; a ciência tem ação própria. */
export const EVENTOS_MANIFESTACAO_CONCLUSIVA_NFE = EVENTOS_MANIFESTACAO_NFE
  .filter(x => x.idTipoEvento !== TipoEventoNFeEnum.CienciaEmissao);

/** Nota cancelada ou com a operação já confirmada não aceita nova manifestação. */
export function isManifestacaoBloqueada(isCancelada: boolean, idTipoEventoManifestacaoAtual: number | null): boolean {
  return isCancelada || idTipoEventoManifestacaoAtual === TipoEventoNFeEnum.ConfirmacaoOperacao;
}
